import React from 'react';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';
import { Tag } from 'primereact/tag';
import { Routine, ROUTINE_TYPES } from '../../types/Fisiofit/routine';
import { RoutineForm } from './validators';
import { DaysRemainingSeverity } from './types';

interface RoutinePanelHeaderProps {
  isNextRoutine: boolean;
  creatingNewRoutineForExpired: boolean;
  onGoBack: () => void;
  title: string;
  hasEnded: boolean;
  currentRoutine: Routine | undefined;
  isCreating: boolean;
  form: RoutineForm;
  daysDifference: number | null;
  isEndingSoon: boolean;
  daysRemainingSeverity: DaysRemainingSeverity;
}

export const RoutinePanelHeader = ({
  isNextRoutine,
  creatingNewRoutineForExpired,
  onGoBack,
  title,
  hasEnded,
  currentRoutine,
  isCreating,
  form,
  daysDifference,
  isEndingSoon,
  daysRemainingSeverity,
}: RoutinePanelHeaderProps) => {
  return (
    <div className='routine-panel-header'>
      {(isNextRoutine || creatingNewRoutineForExpired) && (
        <Button icon={PrimeIcons.ARROW_LEFT} className='p-button-text' onClick={onGoBack} />
      )}
      <h4>{title}</h4>
      {hasEnded && !currentRoutine?.isExpired && <Tag value='Rutina pasada' severity='contrast' />}
      {isNextRoutine && <Tag value='Próxima rutina' severity='info' />}
      {!isCreating &&
        !isNextRoutine &&
        !currentRoutine?.isExpired &&
        form.routineType === ROUTINE_TYPES.USER &&
        daysDifference !== null &&
        daysDifference < 0 && <Tag value='Aún no ha comenzado' severity='info' />}
      {!isCreating && isEndingSoon && (
        <Tag value='Termina pronto' severity={daysRemainingSeverity === 'error' ? 'danger' : daysRemainingSeverity} />
      )}
      {currentRoutine?.isExpired && <Tag value='Rutina caducada' severity='danger' />}
    </div>
  );
};
